import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {useSelector} from 'react-redux';
import Header from "../layout/Sidebar/Header";
import SideMenu from "../layout/Sidebar/SideMenu";

const PrivateRoute = ({component: Component, ...rest}) => {
    const auth = useSelector((state) => state.auth);
    return(
        <Route
            {...rest}
            render={props =>
                auth.isAuthenticated === true ? (
                    <div className="antialiased flex h-full text-base text-foreground bg-background [--header-height:100px] data-[kt-sticky-header=on]:[--header-height:60px]">
                        <div className="flex grow flex-col in-data-[kt-sticky-header=on]:pt-(--header-height)">
                            <Header/>
                            <main className="grow" id="content" role="content">
                                <Component {...props} />
                            </main>
                        </div>
                    </div>
                ) : (
                <Redirect to="/"/>
                )
            }
        />
    )
};

export default PrivateRoute;
